<template>
  <div class="remove-demo">
    <Button
      v-if="store.getters['settings/hasDemo']"
      class="remove-demo-button"
      :label="$t('remove_demo')"
      outline
      small
      variant="secondary"
      @click="() => removeDemoModal.show()"
    />
    <Modal ref="removeDemoModal">
      <template #header>{{ $t('remove_demo') }}</template>
      <template #body>
        <Text type="p">{{ $t('remove_demo_text') }}</Text>
      </template>
      <template #footer>
        <Button :label="$t('cancel')" outline variant="secondary" @click="() => removeDemoModal.hide()" />
        <Button :label="$t('remove')" variant="secondary" background-color="#d45252" @click="removeDemo" />
      </template>
    </Modal>
  </div>
</template>

<script setup>
import { ref, defineEmits } from 'vue';
import { useStore } from 'vuex';
import { Button, Modal, Text } from '@sliday/karma-ui-library';

const store = useStore();
const removeDemoModal = ref(null);
const emit = defineEmits(['remove']);
const removeDemo = () =>
  store.dispatch('auth/removeDemo').then(() => {
    emit('remove');
    location.reload();
  });
</script>

<style scoped lang="scss">
.remove-demo {
  &-button {
    color: #1c2e39 !important;
    border-color: #e2e8ee !important;
  }
  button + button {
    margin-left: 10px;
  }
}
</style>
